// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"E--z"};